import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { ajax } from "jquery";
// import 'bootstrap/dist/css/bootstrap.min.css';

import ElementMessage from '../../components/common/elementmessage';
import ContentTitle from '../../components/common/container/title';
import InlineData from '../../components/forms/inlinedata';
import Button from '../../components/forms/button';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import TableImgData from './IHN0101-imgtable';
import FilterForm from './IHN0101-filter'
import Translate from '../../components/common/translate'
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
const getTranslateValue = Utils.getTranslateValue;

const API = {
   GetAllBunrui1: window.domainDir + "api/Product/RetrieveBunrui1",
   GetProductsByFilterUrl: window.domainDir + "api/Product/GetProductsByFilter",
   GETLOADCATEGORIES: window.domainDir + "api/Product/GetAllBunrui1",
   GETPRODUCTPDFFILE: window.domainDir + "api/Product/GetProductPdfFile",
   GetInfoMessageGaibu: window.domainDir + "api/Product/GetInfoNinushiMessageGaibu",
   DOWNLOADPDF: window.domainDir +"api/Download/DownloadPDF",
   GETS3DOWNLOADFILEPATH: window.domainDir + "api/Product/GetS3DownloadFilePath"
}

const IHN0101Master = (props) => {
    let translate = useRef(null);
    let history = useHistory();

    const [newProducts, setNewProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [productsWithSpotData, setProductsWithSpotData] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [bunrui1Options, setBunrui1Options] = useState([]);
    const [infoMessageGaibu, setInfoMessageGaibu] = useState("");

    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [activeTab, setActiveTab] = useState('tab2');
    
    const [translateSuccess, setTranslateSuccess] = useState(false);


    useEffect(() => {
        clearMessage();
        setSelectedProducts(props.selectedProducts);
        setNewProducts(props.selectedProducts);
        setProductsWithSpotData(props.selectedProducts);
        getBunrui1Options();
        getInfoMessageGaibu();
    }, []);

     function getBunrui1Options(){
        ajax({
            url: API.GetAllBunrui1,
            type: 'GET',
            data: {},
            credentials: 'same-origin'
        }).done(json => {
            let list = JSON.parse(json).Response;
            let optionList = [];
            optionList.push({value: 0, label: "", BunruiCode: null, BunruiId: null});
            if(!Utils.isNullOrEmpty(list)){
                list.map(function(option, index) {
                    optionList.push({value: index + 1, label: option.BunruiName1, BunruiCode: option.BunruiCode1, BunruiId: option.BunruiId1});
                });
                setBunrui1Options([...optionList]);
            }
        }).fail(json => {
            setStatusMessage( CONST.ApiResult.Error, getTranslateValue(translate.current, "messages.common.exceptionerror"));
        })
    }

    function getInfoMessageGaibu() {
        ajax({
            url: API.GetInfoMessageGaibu,
            type: 'GET',
            data: {},
            credentials: 'same-origin'
        }).done(json => {
            let response = JSON.parse(json);
            if (response.Status == CONST.ApiResult.Success) {
                setInfoMessageGaibu(response.Response);
            } else {
                setInfoMessageGaibu("");
            }
        }).fail(json => {
            setStatusMessage( CONST.ApiResult.Error, getTranslateValue(translate.current, "messages.common.exceptionerror"));
        });
    }

    function onPageChange(pageNo, sizePerPage) {
        setPageNo(pageNo);
        // setSizePerPage(sizePerPage);
    }

    function handleQuantity(value , row){
        let newData = [];
        value = value.replace(/^0+/, '');
        newProducts.forEach(element => {
            if(element.HansokuId === row.HansokuId){
                element.IraiQt = (value != "" && value > 0)? value : 0;
            }
            newData.push(element);
        });
        setNewProducts(newData);
        productsWithSpotData.forEach(element => {
            if(element.HansokuId === row.HansokuId){
                element.IraiQt = (value != "" && value > 0)? value : 0;
            }
        });
    }
    
    function handleProducts(products){
        clearMessage();
        setNewProducts(products);
        if(null != products){
            if(null != productsWithSpotData){
                products = products.filter(x => false == productsWithSpotData.some(h => h.HansokuId == x.HansokuId));
                products = productsWithSpotData.concat(products);
            }
        }
        setProductsWithSpotData(products);

    }

    function handleAddToCart(product){

        if (product.IraiQt == null || product.IraiQt <= 0 || isNaN(product.IraiQt)) {
            setStatusMessage( CONST.ApiResult.Error, `${ product.HansokuName + " " + getTranslateValue(translate.current, "views.ihn0101.oneorder")}`);
            Utils.scrollToTop();
            return;
        }

        if(product.ZaikoQt < product.IraiQt && product.Podkbn != true){
            const exceedMsg = getTranslateValue(translate.current, "views.ihn0101.exceedinventory"); 

            const extraMsg = getTranslateValue(translate.current, "views.ihn0101.exceedinventory2") +
                getTranslateValue(translate.current, "views.ihn0101.exceedinventory3") +
                getTranslateValue(translate.current, "views.ihn0101.exceedinventory4") +
                getTranslateValue(translate.current, "views.ihn0101.exceedinventory5") +
                getTranslateValue(translate.current, "views.ihn0101.exceedinventory6");

            setStatusMessage(CONST.ApiResult.Error, `${product.HansokuName} ${exceedMsg}\n\n${extraMsg}`);

            Utils.scrollToTop();
            return;
        }

        var sessionCart = sessionStorage.getItem('sessionCart');
        let temporaryCart = [];
        if(null != sessionCart){
            temporaryCart = JSON.parse(sessionCart);
        }

        const existingIndex = temporaryCart.findIndex(
            (item) => item.HansokuId === product.HansokuId
        );

        if (existingIndex !== -1 ) {
            let total = temporaryCart[existingIndex].IraiQt + product.IraiQt;
            if( total <= 50) temporaryCart[existingIndex].IraiQt = total;
            else temporaryCart[existingIndex].IraiQt = 50;
        } else {
            temporaryCart.push(product);
        }
        sessionStorage.setItem("sessionCart", JSON.stringify(temporaryCart));
        history.push(`/Cart/List`);
    }

    function setStatusMessage(status, message){
        setStatus(status);
        setMessage(message);
    }

    function clearMessage() {
        setStatus("");
        setMessage("");
    }

    // function downloadPDF(samplePDFFileName, hansokuCode, hansokuSubCode) {
    //     clearMessage();
    //     var criteria = {
    //         fileName: samplePDFFileName,
    //         hansokuCode: hansokuCode,
    //         hansokuSubCode: hansokuSubCode
    //     }

    //     sessionStorage.setItem("downloadPDFParams", JSON.stringify(criteria));
    //     history.push("/Product/DownloadPDF");
    // }

    function downloadPDF(samplePDFFileName, hansokuCode, hansokuSubCode) {
        $("#loading").fadeIn();
        clearMessage();

        var criteria = {
            fileName: samplePDFFileName,
            hansokuCode: hansokuCode,
            hansokuSubCode: hansokuSubCode
        }
        // var criteria = JSON.parse(sessionStorage.getItem('downloadPDFParams'));
        const facilityInfo = JSON.parse(sessionStorage.getItem(CONST.SessionData.FACILITYINFO));
        ajax({
            url: API.GETS3DOWNLOADFILEPATH,
            type: 'GET',
            data: criteria,
            credentials: 'same-origin'
        }).done(response => {
            let result = JSON.parse(response);
                  if (result.Status == CONST.ApiResult.Success) {
                    let filePath = result.Message;

                    // only the inputted facility fields
                    const facilityLog = facilityInfo ? {
                        PostalCode: facilityInfo.PostalCode,
                        Address: facilityInfo.Address,
                        FacilityName: facilityInfo.FacilityName,
                        PhoneNumber: facilityInfo.PhoneNumber,
                        Fax: facilityInfo.Fax,
                        KanjiFirstName: facilityInfo.KanjiFirstName,
                        KanjiLastName: facilityInfo.KanjiLastName,
                        KanaFirstName: facilityInfo.KanaFirstName,
                        KanaLastName: facilityInfo.KanaLastName,
                        Email: facilityInfo.Email,
                        // ConfirmEmail: facilityInfo.ConfirmEmail,
                        DepartmentName: facilityInfo.DepartmentName
                    } : null;

                    const params = new URLSearchParams({
                        fileName: filePath,
                        hansokuCode: criteria.hansokuCode,
                        facilityLog: JSON.stringify(facilityLog)
                    });
                    window.location = `${API.DOWNLOADPDF}?${params.toString()}`;
                  } else {
                    setStatusMessage(CONST.ApiResult.Error, result.Message);
                }
        }).fail(json => {
            setStatusMessage( CONST.ApiResult.Error, getTranslateValue(translate.current, "messages.common.exceptionerror"));
        })
        $("#loading").fadeOut();
    }


    return (
        <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this,true)}>
            <ContentTitle active="#IHN0101" title={getTranslateValue(translate.current, isMobile? "views.titleText.ihn0101mobile" : "views.titleText.ihn0101")} />
                        <div className="main-content">
                <div className="container-fluid" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    {
                        null == message || "" == message ?
                            null
                            :
                            <div style={{ marginLeft: '-20px', marginRight: '-20px', whiteSpace: 'pre-wrap' }}>
                                <ElementMessage message={message} status={status} clearMessage={clearMessage.bind(this)} />
                            </div>
                    }
                    {infoMessageGaibu && (
                        <div className="mb-2" style={{ width: "100%", backgroundColor: "#e8f4ff", border: "1px solid #b9dcff", border: "1px solid #b9dcff", boxSizing: "border-box", whiteSpace: "pre-wrap", padding: "14px 16px", marginBottom: "15px", textAlign: 'justify' }}>{infoMessageGaibu}</div>
                    )}
                    <div className="mb-2" style={{ fontWeight: "bold", whiteSpace: "pre-wrap", marginBottom: "30px" }}>
                        {getTranslateValue(translate.current, "views.ihn0101.permanentnotice1")}{"\n"}
                        {getTranslateValue(translate.current, "views.ihn0101.permanentnotice2")}
                    </div>
                <FilterForm 
                    getTranslateValue={getTranslateValue.bind(this)}
                    translate={translate}
                    bunrui1Options={bunrui1Options}
                    GetProductsByFilterUrl={API.GetProductsByFilterUrl}
                    // selectedProducts={selectedProducts}
                    newProducts={newProducts}
                    setNewProducts={handleProducts.bind(this)}
                />
                  <div className="tab-content">
                        {renderImgTable()}
                  </div>
                
                </div>
            </div>
        </Translate>
    )

    function renderImgTable(){
        return(
            <div className="col-sm-12" style={{paddingBottom:"15px"}}>
                {newProducts && newProducts.length > 0 ? (
                <TableImgData
                    data={newProducts}
                    handleQuantity={handleQuantity.bind(this)}
                    translate={translate}
                    getTranslateValue={getTranslateValue.bind(this)}
                    getImageDataUrl={props.getImageDataUrl}
                    pageNo={pageNo}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage.bind(this)}
                    onPageChange={onPageChange.bind(this)}
                    handleAddToCart={handleAddToCart.bind(this)}
                    downloadPDF={downloadPDF.bind(this)}
                    isMobile={isMobile}
                />
                ) : (
                <div style={{  textAlign: "center" }}>
                    <br/>
                    <hr />
                    {getTranslateValue(translate.current, "messages.common.norecord")}
                </div>
                )}
            </div>
        )
    }

}

export default IHN0101Master;


// WEBPACK FOOTER //
// ./view/IHN0101/IHN0101.jsx